import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const unknownErrorRoute: RouteConfig<'with-page'> = {
    name: 'Error - Unknown',
    path: '/error/unknown',
    page: lazy(() => import('.')),
}